import { render, staticRenderFns } from "./housekeeper.vue?vue&type=template&id=4c5b44b7&scoped=true&"
import script from "./housekeeper.vue?vue&type=script&setup=true&lang=js&"
export * from "./housekeeper.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./housekeeper.vue?vue&type=style&index=0&id=4c5b44b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b44b7",
  null
  
)

export default component.exports